import { Component, Input, OnInit, TemplateRef, ContentChild } from '@angular/core';
import { AppContext, WizardContext, WizardTab } from '../control/context';

@Component({
  selector: 'i-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class TabComponent implements OnInit {
  @Input() model: any;
  @Input() mainPath: string = '';
  @Input() mainPath2: string = '';
  @Input() allPaths: string = '';
  @Input() i18n_name: string;
  @Input() showName: boolean;
  @Input() icon: string;

  name: string;
  active: boolean = false;

  private mainPathSteps: string[];
  private mainPath2Steps: string[];
  get visible(): boolean {
    return (
      !this.model ||
      undefined !== this.mainPathSteps.reduce((pv, cv) => (pv === undefined ? undefined : pv[cv]), this.model.features) ||
      undefined !== this.mainPath2Steps.reduce((pv, cv) => (pv === undefined ? undefined : pv[cv]), this.model.features)
    );
  }

  @ContentChild(TemplateRef, { static: true }) template: TemplateRef<any>;

  constructor(private appContext: AppContext, private wizardContext: WizardContext) {}

  ngOnInit() {
    this.mainPathSteps = this.mainPath.split('.');
    this.mainPath2Steps = this.mainPath2.split('.');
    const name = this.appContext.getI18NString(this.i18n_name);
    if (this.showName) {
      this.name = name;
    }
    const tab = new WizardTab();
    tab.paths = this.allPaths.split(',');
    tab.name = name;
    tab.icon = this.icon;
    tab.visible = () => this.visible;
    tab.activate = (active: boolean) => {
      this.active = active;
    };
    tab.key = (this.mainPath + '-' + this.mainPath2 + this.i18n_name).replace('.', '-');
    this.wizardContext.registerTab(tab);
  }
}
